import * as Types from 'src/actions/investment/index/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import IndexResponse from 'src/value-objects/IndexResponse';
import Investment from 'src/entities/Investment';

export interface IndexInvestmentsAttempt extends Action {
  type: Types.INDEX_INVESTMENT_ATTEMPT;
}

export interface IndexInvestmentsSuccess extends Action {
  type: Types.INDEX_INVESTMENT_SUCCESS;
  payload: Investment[];
}

export interface IndexInvestmentsFailure extends Action {
  type: Types.INDEX_INVESTMENT_FAILURE;
}

export type IndexInvestmentsAction = IndexInvestmentsAttempt |
  IndexInvestmentsSuccess |
  IndexInvestmentsFailure;

export interface IndexInvestmentsThunk
  extends ThunkAction<Promise<IndexInvestmentsAction>, RootState, string> {
}

export const indexInvestmentsAttempt: ActionCreator<IndexInvestmentsAttempt> = () => (
  {
    type: Types.INDEX_INVESTMENT_ATTEMPT
  }
);

export const indexInvestmentsSuccess: ActionCreator<IndexInvestmentsSuccess> = (
  investments: Investment[]
) => ({
  type: Types.INDEX_INVESTMENT_SUCCESS,
  payload: investments
});

export const indexInvestmentsFailure: ActionCreator<IndexInvestmentsFailure> = () => ({
  type: Types.INDEX_INVESTMENT_FAILURE
});

export const indexInvestments: ActionCreator<IndexInvestmentsThunk> = (
  profileId: number,
  profileType: string,
  lastYear: boolean,
  projectId?: number
): IndexInvestmentsThunk => {
  return (dispatch: Dispatch<RootState>): Promise<IndexInvestmentsAction> => {
    dispatch(indexInvestmentsAttempt());
    return ApiClient.investment.index({
      personId: profileId,
      personType: profileType,
      lastYear: lastYear,
      projectId: projectId
    }).then((response: AxiosResponse<IndexResponse<Investment>>): IndexInvestmentsSuccess => {
      return dispatch(indexInvestmentsSuccess(response.data.content));
    }).catch((): IndexInvestmentsFailure => {
      return dispatch(indexInvestmentsFailure());
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/investment/index/IndexInvestments.actions.tsx